import { ParallaxDirection, ParallaxLayer, ParallaxType } from '../../../core/modules/Parallax/ParallaxController';
import { Theme, ThemeName, Weather } from './theme';

export const themeFrozenStreet: Theme = {
  id: ThemeName.FrozenStreet,
  texture: 'theme-frozenstreet',
  isNight: false,
  isSky: false,
  weather: Weather.Dry,
  roadDetails: {
    laneCount: 4,
    lanes: {
      0: { laneY: 86 },
      1: { laneY: 90 },
      2: { laneY: 95 },
      3: { laneY: 100 }
    },
    laneHeight: 100,
    laneScale: 0.05,
    laneVehicleScale: 0.025,
    startPointX: -1300,
    startPointY: 166,
    vehicleOffset: 10,
    obstacleOffset: -20,
    pavementY: 378,
    pavementHeight: 77,

    roadStartY: 52,
    roadEndY: 374
  },
  parallaxLayers: [
    {
      type: ParallaxType.Sprite,
      layer: ParallaxLayer.Background,
      direction: ParallaxDirection.Horizontal,
      x: 0,
      y: 166,
      texture: 'theme-frozenstreet',
      images: [
        {
          frame: 'tile-sky-frozenstreet.png',
          gapBefore: -2
        },
        {
          frame: 'tile-sky-frozenstreet.png',
          gapBefore: -2
        },
        {
          frame: 'tile-sky-frozenstreet.png',
          gapBefore: -2
        }
      ],
      depth: 1,
      scrollX: 0,
      scrollY: 0,
      speedX: 0.1,
      speedY: 0,
      naturalDriftX: 0,
      naturalDriftY: 0
    },
    {
      type: ParallaxType.Sprite,
      layer: ParallaxLayer.Background,
      direction: ParallaxDirection.Horizontal,
      x: 0,
      y: 178,
      texture: 'theme-frozenstreet',
      images: [
        {
          frame: 'tile-bg-frozenstreet.png',
          gapBefore: -2
        },
        {
          frame: 'tile-bg-frozenstreet.png',
          gapBefore: -2
        },
        {
          frame: 'tile-bg-frozenstreet.png',
          gapBefore: -2
        }
      ],
      depth: 2,
      scrollX: 0,
      scrollY: 0,
      speedX: 0.6,
      speedY: 0,
      naturalDriftX: 0,
      naturalDriftY: 0
    },
    {
      type: ParallaxType.Sprite,
      layer: ParallaxLayer.Background,
      direction: ParallaxDirection.Horizontal,
      x: 0,
      y: 390,
      texture: 'theme-frozenstreet',
      images: [
        {
          frame: 'tile-mid-frozenstreet.png',
          gapBefore: -2
        },
        {
          frame: 'tile-mid-frozenstreet.png',
          gapBefore: -2
        },
        {
          frame: 'tile-mid-frozenstreet.png',
          gapBefore: -2
        }
      ],
      depth: 4,
      scrollX: 0,
      scrollY: 0,
      speedX: 1,
      speedY: 0,
      naturalDriftX: 0,
      naturalDriftY: 0
    },
    {
      type: ParallaxType.Sprite,
      layer: ParallaxLayer.Foreground,
      direction: ParallaxDirection.Horizontal,
      x: 0,
      y: 384,
      texture: 'game',
      images: [
        {
          frame: 'tile-speedlines.png',
          gapBefore: 0
        },
        {
          frame: 'tile-speedlines.png',
          gapBefore: 0
        },
        {
          frame: 'tile-speedlines.png',
          gapBefore: 0
        }
      ],
      depth: 4,
      scrollX: 0,
      scrollY: 0,
      speedX: 4,
      speedY: 0,
      naturalDriftX: 1,
      naturalDriftY: 0,
      alphaToSpeedRatio: 0.02,
      tint: 0xfd98e1
    }
  ]
};
